import { TableCell, TableHeader, TableRow, Text } from "grommet";
import { memo } from "react";

export const AuctionTableHeader = memo(({ columns }) => (
    <TableHeader>
        <TableRow>
            {columns.map(row => (
                <TableCell key={row.id} scope="col" border="bottom"><Text weight="bold">{row.header}</Text></TableCell>
            ))}
        </TableRow>
    </TableHeader>
))